import { Dialog, Flex, Image, Text } from "@fluentui/react-northstar";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { ConnectedPrivacyFooter } from "../privacy-footer/ConnectedPrivacyFooter";

import { PermissionDeniedProps } from "./permissionDenied.types";
import { usePermissionDeniedStyles } from "./PermissionDenied.styles";

export const PermissionDeniedPopup: React.FC<PermissionDeniedProps> = ({
  cameraAccess,
  micAccess,
  isInfoFetched,
}) => {
  const permissionDeniedStyles = usePermissionDeniedStyles();
  const { t } = useTranslation();

  const micAndCamDenied = t("ACCESS_PERMISSION_REJECTED");
  const cameraAccessDenied = t("CAMERA_ACCESS_DENIED");
  const micAccessDenied = t("MIC_ACCESS_DENIED");

  const [permissionHeader, setPermissionHeader] = useState(micAndCamDenied);

  useEffect(() => {
    // Set dialog header text based on which permissions are granted
    if (!cameraAccess && !micAccess) {
      setPermissionHeader(micAndCamDenied);
    } else if (!cameraAccess) {
      setPermissionHeader(cameraAccessDenied);
    } else if (!micAccess) {
      setPermissionHeader(micAccessDenied);
    }
  }, [
    cameraAccess,
    micAccess,
    micAndCamDenied,
    cameraAccessDenied,
    micAccessDenied,
  ]);

  return (
    <Dialog
      styles={permissionDeniedStyles.container}
      open={(!cameraAccess || !micAccess) && isInfoFetched}
      content={
        <Flex column vAlign="center" hAlign="center" gap="gap.small">
          <Image
            alt={t("ISSUE_IMAGE_ALT")}
            styles={permissionDeniedStyles.connectionIcon}
            src={"/assets/images/connectionFailureIcon.svg"}
          />

          <Text
            as="h1"
            size="larger"
            weight="bold"
            align="center"
            styles={permissionDeniedStyles.headerLabel}
            content={<>{permissionHeader}</>}
          />

          <Text
            styles={permissionDeniedStyles.descriptionLabel}
            size="large"
            weight="regular"
            align="center"
            content={<>{t("CAM_AND_MIC_PERMISSION_DENIED")}</>}
          />
        </Flex>
      }
      footer={
        <Flex column fill gap="gap.medium" vAlign="end">
          <Text
            size="medium"
            weight="regular"
            align="center"
            content={
              <Text>
                <Text content={<>{t("NEED_HELP_CONTACT_CLINIC")}</>} />
              </Text>
            }
          />
          <ConnectedPrivacyFooter />
        </Flex>
      }
    />
  );
};
